export function setPuntos(state, puntos) {
    state.puntos = puntos;
}

export function setPuntoSelec(state, punto) {
    state.puntoSelec = punto;
}

export function actListPuntos(state, punto) {
    if (punto !== null) {
        const index = state.puntos.findIndex(r => r.id === punto.id)
        if (index != -1) {
            state.puntos[index].nombre = punto.nombre;  
            state.puntos[index].provincia = punto.provincia;  
            state.puntos[index].descripcion = punto.descripcion;  
            state.puntos[index].localizacion = punto.localizacion;  
            state.puntos[index].avatar = punto.avatar;  
        }
    }
}

export function actDeleteListPuntos(state, id) {
    if (id != null) {
        const index = state.puntos.findIndex(r => r.id === id)
        if (index != -1) {
            state.puntos.splice(index, 1)
        }
    }
}

export function actListProveedoresFromPuntos(state, proveedor) {
    if (proveedor !== null) {
        for (let i = 0; i < state.puntos.length; i++) {
            const index = state.puntos[i].proveedores.findIndex(r => r.id === proveedor.id)
            if (index != -1) {
                state.puntos[i].proveedores[index].nombre = proveedor.nombre;
                state.puntos[i].proveedores[index].tipo = proveedor.tipo;
                state.puntos[i].proveedores[index].descripcion = proveedor.descripcion;
                state.puntos[i].proveedores[index].categoria = proveedor.categoria;
                state.puntos[i].proveedores[index].telefono = proveedor.telefono;
                state.puntos[i].proveedores[index].email = proveedor.email;
                state.puntos[i].proveedores[index].web = proveedor.web;
                state.puntos[i].proveedores[index].responsable = proveedor.responsable;
                state.puntos[i].proveedores[index].localizacion = proveedor.localizacion;
                state.puntos[i].proveedores[index].orden = proveedor.orden;
                state.puntos[i].proveedores[index].request_tipo = proveedor.request_tipo;
                state.puntos[i].proveedores[index].request_automatico = proveedor.request_automatico;
                state.proveedores[index].activo = proveedor.activo;
                state.puntos[i].proveedores[index].punto_id = proveedor.punto_id;
            }
        }
    }
}

export function actDeleteListProveedoresFromPuntos(state, id) {
    if (id != null) {
        for (let i = 0; i < state.puntos.length; i++) {
            const index = state.puntos[i].proveedores.findIndex(r => r.id === id)
            if (index != -1) {
                state.puntos[i].proveedores.splice(index, 1)
            }
        }
    }
}